<template>
  <div class="personal">
    <!-- <top-nav ref="TopNav"></top-nav>
    <van-nav-bar title="设置" fixed >
      <van-icon slot="left" class="iconfont icon-zuojiantou" style="font-size: .25rem" @click="goBack"></van-icon>
      <van-icon slot="right" class="iconfont icon-zhankai" @click="onClickRight() "></van-icon>
    </van-nav-bar> -->
    <GlobTopNav title="设置"></GlobTopNav>

    <div class="van-content">
      <div class="cell-list">
        <div class="van-cell van-hairline userheaderbox">
          <div class="van-cell__title">
            <span>我的头像</span>
          </div>
          <div class="van-cell__value">
            <div class="userheader">
              <!--<img :src="header==''?'/static/images/userheaderimg.png':header">-->
              <img
                v-if="this.$store.state.userCount.image == null"
                :src="
                  this.$store.state.userCount.user_icon == null
                    ? '/static/images/userheaderimg.png'
                    : this.$store.state.userCount.user_icon
                "
                onerror="src='/static/images/userheaderimg.png'"
              />
              <img
                :src="this.$store.state.userCount.image"
                v-if="this.$store.state.userCount.image != null"
                onerror="src='/static/images/userheaderimg.png'"
              />
            </div>
            <!--<label for="upfile" class="userheader">-->
            <!--<img :src="header==''?'/static/images/userheaderimg.png':header">-->
            <!--</label>-->
            <!--<input id="upfile" name="upfile" class="upload" @change='onRead' accept="image/gif,image/jpg,image/jpeg,image/png" type="file" hidden>-->
          </div>
          <!--<i class="van-icon van-icon-arrow van-cell__right-icon"></i>-->
        </div>
        <div class="van-cell van-hairline nicknameCont">
          <div class="van-cell__title">
            <span>用户名</span>
          </div>
          <div class="van-cell__value" v-html="this.$store.state.userCount.account"></div>
          <!--<i class="van-icon van-icon-arrow van-cell__right-icon"></i>-->
        </div>
        <div class="van-cell van-hairline nicknameCont" @click="nicknamePlay()">
          <div class="van-cell__title">
            <span>昵称</span>
          </div>
          <!--<div class="van-cell__value ">{{ name }}</div>-->
          <!--<div class="van-cell__value "  v-if="this.$store.state.userCount.wechat_name!=null" v-html="this.$store.state.userCount.wechat_name==null?'未设置昵称':this.$store.state.userCount.wechat_name" ></div>-->
          <!--<div class="van-cell__value " v-if="this.$store.state.userCount.wechat_name==null" v-html="this.$store.state.userCount.user_name==''?'未设置昵称':this.$store.state.userCount.user_name" ></div>-->
          <div
            class="van-cell__value"
            v-html="
              this.$store.state.userCount.user_name == null
                ? '未设置昵称'
                : this.$store.state.userCount.user_name
            "
          ></div>
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
        <!--<div class="van-cell van-hairline">-->
        <!--<div class="van-cell__title">-->
        <!--<span>会员等级</span>-->
        <!--</div>-->
        <!--<div class="van-cell__value">{{ level_name }}</div>-->
        <!--</div>-->
        <!--<div class="van-cell van-hairline" @click="sexPlay()">-->
        <!--<div class="van-cell__title">-->
        <!--<span>性别</span>-->
        <!--</div>-->
        <!--<div class="van-cell__value">{{ sex == 1?'女':sex == 0?'男':''}}</div>-->
        <!--<i class="van-icon van-icon-arrow van-cell__right-icon"></i>-->
        <!--</div>-->
        <!--<div class="van-cell van-hairline" @click="birthdayChange()">-->
        <!--<div class="van-cell__title">-->
        <!--<span>生日</span>-->
        <!--</div>-->
        <!--<div class="van-cell__value">{{ birthday }}</div>-->
        <!--<i class="van-icon van-icon-arrow van-cell__right-icon"></i>-->
        <!--</div>-->
        <!--<van-cell class="telnumber" to="/user/personal/phone" is-link title="手机号码" :value="phone"/>-->
        <div class="van-cell van-hairline nicknameCont" @click="gochange()">
          <div class="van-cell__title">
            <span>手机号码</span>
          </div>
          <div
            class="van-cell__value"
            v-html="
              this.$store.state.userCount.mobile == null
                ? '未绑定'
                : this.$store.state.userCount.mobile
            "
          ></div>
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
      </div>

      <div class="cell-list" style="margin-top: 0.2rem">
        <div class="van-cell van-hairline nicknameCont" @click="passwordPlay()">
          <div class="van-cell__title">
            <span>修改密码</span>
          </div>
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
      </div>

      <!--性别选择-->
      <!-- <van-actionsheet v-model="sexShow" :actions="sexDatas" cancel-text="取消" /> -->
      <!--生日选择-->
      <van-popup v-model="birthdayShow">
        <div>
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="birthdayConfirm"
            @cancel="birthdayCancel"
          />
        </div>
      </van-popup>
      <!--昵称弹窗-->
      <van-dialog
        v-model="nicknameShow"
        show-cancel-button
        class="nicknameinput"
        @confirm="nicknameConfirm"
      >
        <div class="van-dialog__header">修改昵称</div>
        <van-field v-model="nicknameIn" :placeholder="name" />
      </van-dialog>
    </div>
  </div>
</template>

<script>
import TopNav from '../../../components/topnav'
import store from './../../../vuex/store'

export default {
  name: 'index',
  components: { TopNav },
  data() {
    return {
      nicknameIn: '',
      name: '',
      level_name: '',
      phone: '',
      header: '',
      sex: null,
      birthday: '',
      currentDate: new Date(),
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      nicknameShow: false,
      birthdayShow: false,
      sexShow: false,
      sexDatas: [
        {
          name: '男',
          value: 0,
          callback: this.sexChange
        },
        {
          name: '女',
          value: 1,
          callback: this.sexChange
        }
      ],
      imgs: [],
      imgData: {
        accept: 'image/gif, image/jpeg, image/png, image/jpg'
      }
    }
  },
  methods: {
    goBack: function () {
      history.back(-1)
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay()
    },
    passwordPlay() {
      this.$router.push({ path: '/user/personal/password' })
    },
    sexPlay: function () {
      this.sexShow = true
    },
    gochange: function () {
      this.$router.push({ name: 'Phone' })
    },
    nicknamePlay: function () {
      this.$router.push({ name: 'Changename' })
    },
    //      getDatas:function () {
    //        let isUser = localStorage.getItem("BLHuser")
    //        this.$api.post('WebApi/Member/Info/index', {token:isUser}, res => {
    //          this.sex = res.data.data.sex
    //          this.header = res.data.data.user_icon
    //          this.birthday = res.data.data.birthday
    //          this.phone = res.data.data.mobile
    //          this.level_name = res.data.data.level_name
    //          this.name = res.data.data.name
    //        })
    //      },
    sexChange: function (item) {
      this.sexShow = false
      let isUser = localStorage.getItem('BLHuser')
      if (item.value != this.sex) {
        const toast = this.$toast.loading({
          mask: true,
          duration: 0
        })
        this.$api.post('WebApi/Member/Info/updatesex', { token: isUser, sex: item.value }, res => {
          if (res.data.code == '100') {
            this.sex = item.value
            toast.clear()
          } else {
            this.$toast(res.data.message)
          }
        })
      }
    },
    birthdayChange: function () {
      this.birthdayShow = true
    },
    birthdayConfirm: function () {
      let isUser = localStorage.getItem('BLHuser')
      this.birthdayShow = false
      var y = this.currentDate.getFullYear()
      var m = this.currentDate.getMonth() + 1
      var d = this.currentDate.getDate()
      var birthdaydata = y + '-' + m + '-' + d
      const toast = this.$toast.loading({
        mask: true,
        duration: 0
      })
      this.$api.post(
        'WebApi/Member/Info/setMemberBirthday',
        { token: isUser, birthday: birthdaydata },
        res => {
          if (res.data.code == '100') {
            this.birthday = y + '-' + m + '-' + d
            toast.clear()
          } else {
            this.$toast(res.data.message)
          }
        }
      )
    },
    nicknameConfirm: function () {
      let isUser = localStorage.getItem('BLHuser')
      const toast = this.$toast.loading({
        mask: true,
        duration: 0
      })
      this.$api.post(
        'WebApi/Member/Info/setMemberName',
        { token: isUser, name: this.nicknameIn },
        res => {
          if (res.data.code == '100') {
            this.name = this.nicknameIn
            toast.clear()
          } else {
            this.$toast(res.data.message)
          }
        }
      )
    },
    birthdayCancel: function () {
      this.birthdayShow = false
    },
    onRead: function (event) {
      let isUser = localStorage.getItem('BLHuser')
      let reader = new FileReader()
      let img1 = event.target.files[0]
      let type = img1.type //文件的类型，判断是否是图片
      let size = img1.size //文件的大小，判断图片的大小
      if (this.imgData.accept.indexOf(type) == -1) {
        this.$toast.alert('请选择我们支持的图片格式！')
        return false
      } else if (size > 3145728) {
        this.$toast.alert('请选择3M以内的图片！')
        return false
      } else {
        const toast = this.$toast.loading({
          mask: true,
          message: '上传中...',
          duration: 0
        })
        var uri = ''
        let form = new FormData()
        form.append('file', img1, img1.name)
        this.$api.file('WebApi/Member/Info/setMemberPic?token=' + isUser, form, res => {
          uri = res.data.url
          reader.readAsDataURL(img1)
          var that = this
          reader.onloadend = function () {
            that.imgs.push(uri)
          }
          this.header = res.data.data.pic
          toast.clear()
        })
      }
    }
  },
  mounted() {
    //      this.getDatas()
    this.$store.commit('userInfo')
  }
}
</script>

<style lang="less">
.personal {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
  .van-content {
    .cell-list {
      .van-cell {
        width: 100vw;
        box-sizing: border-box;
        position: relative;
        border-bottom: 0.02rem solid #f5f5f5;
        display: flex;
        align-items: center;
        padding: 0.3rem 0.3rem;

        &::after {
          content: none;
        }

        .van-cell__title {
          font-size: 0.28rem;
          font-weight: 500;
          color: rgba(38, 38, 38, 0.8);
          line-height: 0.48rem;
        }

        .van-cell__value {
          display: flex;
          justify-content: flex-end;
          .userheader {
            width: 1.08rem;
            height: 1.08rem;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/personal/index.vue